import {createIcon, Svg} from "@gluestack-ui/icon";
import {Path} from "react-native-svg";

const StarProcessingIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 14 14",
  path: (
    <>
      <Path
        d="M2.62508 12.8337V9.91699M2.62508 4.08366V1.16699M1.16675 2.62533H4.08341M1.16675 11.3753H4.08341M7.58341 1.75033L6.57181 4.3805C6.4073 4.80821 6.32505 5.02207 6.19714 5.20196C6.08378 5.36139 5.94448 5.50069 5.78505 5.61405C5.60516 5.74196 5.3913 5.82422 4.96358 5.98872L2.33341 7.00033L4.96359 8.01193C5.3913 8.17644 5.60516 8.25869 5.78505 8.3866C5.94448 8.49997 6.08378 8.63926 6.19714 8.79869C6.32505 8.97858 6.4073 9.19244 6.57181 9.62016L7.58342 12.2503L8.59502 9.62016C8.75953 9.19244 8.84178 8.97858 8.96969 8.79869C9.08305 8.63926 9.22235 8.49997 9.38178 8.3866C9.56167 8.25869 9.77553 8.17644 10.2032 8.01193L12.8334 7.00033L10.2032 5.98872C9.77553 5.82422 9.56167 5.74196 9.38178 5.61405C9.22235 5.50069 9.08305 5.36139 8.96969 5.20196C8.84178 5.02207 8.75953 4.80821 8.59502 4.38049L7.58341 1.75033Z"
        stroke="#542D12"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})

export { StarProcessingIcon };


